module.exports = __webpack_public_path__ + "img/HearRo_white_shield.27340362.svg";